import { STATUS, getStatusId } from '@btime/constants'
import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChildrenServiceOrdersState = () => React.useContext(Context)
export const useChildrenServiceOrders = () => useChildrenServiceOrdersState()?.serviceOrders

const QUERY = gql`
  query ServiceOrders($filter: ServiceOrderFilter, $sort: ServiceOrderSort, $permalinkParentToken: String) {
    serviceOrders(filter: $filter, limit: 9999, sort: $sort, permalinkParentToken: $permalinkParentToken) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      scheduling
      status {
        id
        name
      }
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        type
      }
      asset {
        id
        name
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          private
          documents {
            id
            src
            type
            description
          }
          description
          reference
          parentReference
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ChildrenServiceOrderLoader = ({ children, parentId }) => {
  const modalId = useModalData()
  parentId = parentId || modalId
  const permalinkParentToken = usePermalinkToken()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: { parentIds: Number(parentId), statusIds: [getStatusId(STATUS.COMPLETED), getStatusId(STATUS.APPROVED)] },
      sort: { field: 'ID', type: 'ASC' },
      permalinkParentToken: permalinkParentToken
    },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrders}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChildrenServiceOrderLoader
